<template>
  <div class="card-body">
    <h5 class="card-title">
      Delovni nalogi <small class="text-muted" v-show="subTitle">{{ subTitle }}</small>
    </h5>

    <ul>
      <li v-for="w in uniqueWorkers">
        <router-link :to="{ name: 'WorkerEdit', params: { workerId: w.ID } }" target="blank" class="me-2"
          >{{ w.FirstName }} {{ w.LastName }}</router-link
        >
        <span class="badge rounded-pill bg-dark" v-show="w.TransportOfficeHome > 0">Pot domov</span>
        <button
          class="btn btn-primary btn-sm"
          v-if="orderForAssignment?.status === 'Active'"
          @click="$emit('selected', w.ID)"
        >
          Dodeli
        </button>
        <ul>
          <li v-for="so in w.workOrders">
            <span v-if="so.OrderType === 'ServiceOrder'">
              <router-link
                :to="{ name: 'ServiceOrder', params: { workOrderId: so.orderId } }"
                target="_blank"
                class="me-1"
              >
                {{ so.OrderNumber }}
              </router-link>
              <OrderBadge :workOrder="so" />
              <strong class="me-1 mb-1">{{ so.FacilityName }}</strong>
              <small class="text-muted me-1">{{ so.Subject }}</small>
              <span class="badge rounded-pill bg-warning" v-show="so.IsWorkOnWeeked">Vikend delo</span>
            </span>
            <span v-else-if="so.OrderType === 'ProductionOrder'">
              <router-link
                :to="{ name: 'ProductionOrder', params: { workOrderId: so.orderId } }"
                target="_blank"
                class="me-1"
              >
                {{ so.OrderNumber }}
              </router-link>
              <OrderBadge :workOrder="so" v-if="so.Status === 'InProgress'" />
            </span>

            <span v-else>
              <span class="badge rounded-pill bg-warning">Brez nalog</span>
            </span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script setup>
import {
  setError,
  startLoading,
  stopLoading,
  setSuccess,
  clearNotifications,
  setWarning,
} from "../components/Notification"
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { listEntitiesAsync } from "scripts/api"
import { useAuth } from "../composition-api/useAuth"
import ProductionOrder from "scripts/views/ProductionOrder.vue"

defineOptions({ name: "WorkersWithWorkOrdersCard" })

defineProps({
  subTitle: {
    type: String,
  },
  orderForAssignment: {
    type: Object,
  },
})

const emit = defineEmits(["selected", "loaded"])

const { fetchAuthAsync } = useAuth()
const uniqueWorkers = ref([])

const loadDataAsync = async () => {
  const fetchedWorkers = await listEntitiesAsync(fetchAuthAsync, "Analytics/WorkersWithWorkOrders", {})
  const workerMap = new Map()

  fetchedWorkers?.forEach((row) => {
    if (!workerMap.has(row.ID)) {
      let LoggedMinutes = 0
      let IsWorkOnWeeked = false
      if (row.DayOfTheWeek === 1) {
        if (row.LoggedMinutesYesterday > 0) {
          LoggedMinutes = row.LoggedMinutesYesterday
          IsWorkOnWeeked = true
        } else if (row.LoggedMinutesTwoDaysAgo > 0) {
          LoggedMinutes = row.LoggedMinutesTwoDaysAgo
          IsWorkOnWeeked = true
        } else {
          LoggedMinutes = row.LoggedMinutesThreeDaysAgo
        }
      } else {
        LoggedMinutes = row.LoggedMinutesYesterday
      }

      workerMap.set(row.ID, {
        ID: row.ID,
        FirstName: row.FirstName,
        LastName: row.LastName,
        TransportOfficeHome: row.TransportOfficeHome,
        LoggedMinutes,
        workOrders: [],
        IsWorkOnWeeked,
      })
    }
    const workerData = workerMap.get(row.ID)
    workerData.workOrders.push({
      id: row.ID,
      orderId: row.OrderId,
      OrderType: row.OrderType,
      OrderNumber: row.OrderNumber,
      Subject: row.Subject,
      Status: row.Status,
      FacilityName: row.FacilityName,
      IsSpecial: row.IsSpecial,
    })
  })

  uniqueWorkers.value = Array.from(workerMap.values())
  emit("loaded", uniqueWorkers.value)
}

onMounted(async () => {
  await loadDataAsync()
})

defineExpose({ loadDataAsync })
</script>
